<footer class="bottom">
  <div class="footer-content">
    <a class="support" [routerLink]="'/support'" queryParamsHandling="preserve">{{ 'general.ticket_support' | transloco }}</a>
  </div>
</footer>
